import { render, staticRenderFns } from "./RescueOfIndividualCase.vue?vue&type=template&id=c3c8244e&scoped=true&"
import script from "./RescueOfIndividualCase.vue?vue&type=script&lang=js&"
export * from "./RescueOfIndividualCase.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfIndividualCase.vue?vue&type=style&index=0&id=c3c8244e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c8244e",
  null
  
)

export default component.exports